import { useSyncExternalStore } from "react";
import { Link } from "react-router-dom";

/**
 * UN AVVISO CHE SI CHIUDE DA SOLO.
 *
 * Nasce per l'esito di un'eliminazione: la finestra si chiude al successo e la
 * riga che la conteneva sparisce dalla lista, quindi l'esito non puo' stare li'
 * — se ne andrebbe con lei. Sta qui, montato una volta nel `Layout`, e sparisce
 * dopo qualche secondo senza che nessuno debba chiuderlo. Il rosso resta di
 * piu': dice che qualcosa e' rimasto a mercato.
 */
export interface Notice {
  id: number;
  tone: "info" | "alert";
  title: string;
  lines: string[];
  /**
   * Un collegamento facoltativo: dove si rimedia. L'avviso resta di sola
   * lettura; e' il collegamento a ricevere il clic.
   */
  action?: { label: string; to: string };
}

let avvisi: Notice[] = [];
let prossimo = 1;
const ascoltatori = new Set<() => void>();
const avvisa = () => ascoltatori.forEach((f) => f());

/**
 * «XAUUSD non mappato su <server>»: la Fase c'e', il simbolo no. Lo dicono le
 * risposte di aggancio e sostituzione del broker, nascita della Fase e Fase
 * successiva (`symbolWarnings`); «Mappa adesso» porta all'Operazione di quella
 * Fase, che apre da sola la scelta del simbolo sul server che manca.
 */
export function showSymbolWarnings(r: { session: { id: string }; symbolWarnings?: string[] }) {
  if (!r.symbolWarnings?.length) return;
  showNotice(
    {
      tone: "info",
      title: "Fase pronta, ma non si apre finché il simbolo non è mappato",
      lines: r.symbolWarnings,
      action: { label: "Mappa adesso", to: `/operazione?fase=${r.session.id}&mappa=1` },
    },
    20_000,
  );
}

export function showNotice(n: Omit<Notice, "id">, ms = n.tone === "alert" ? 15_000 : 8_000) {
  const id = prossimo++;
  avvisi = [...avvisi, { ...n, id }];
  avvisa();
  setTimeout(() => {
    avvisi = avvisi.filter((a) => a.id !== id);
    avvisa();
  }, ms);
}

const subscribe = (f: () => void) => {
  ascoltatori.add(f);
  return () => {
    ascoltatori.delete(f);
  };
};

export function Notices() {
  const lista = useSyncExternalStore(subscribe, () => avvisi);
  if (!lista.length) return null;
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 w-96 max-w-[calc(100vw-2rem)] space-y-2">
      {lista.map((a) => (
        <div
          key={a.id}
          role={a.tone === "alert" ? "alert" : "status"}
          className={`rounded border bg-surface p-3 text-left shadow-lg ${a.tone === "alert" ? "border-loss" : "border-line"}`}
        >
          <p className={`text-sm font-medium ${a.tone === "alert" ? "text-loss" : "text-ink"}`}>{a.title}</p>
          {a.lines.length > 0 && (
            <ul className="mt-1.5 space-y-0.5">
              {a.lines.map((l, i) => (
                <li key={i} className="text-xs text-muted">
                  {l}
                </li>
              ))}
            </ul>
          )}
          {a.action && (
            <Link to={a.action.to} className="pointer-events-auto mt-2 inline-block text-xs font-medium text-accent hover:underline">
              {a.action.label}
            </Link>
          )}
        </div>
      ))}
    </div>
  );
}
